/* eslint-disable */

/**
 * Dependencies:
 * - Custom select component
 *
 * Required translation strings:
 * - addToCart
 * - noStock
 * - noVariant
 * - onlyXLeft
 */

if (!customElements.get('variant-picker')) {
  class VariantPicker extends HTMLElement {
    constructor() {
      super();
      this.section = this.closest('.js-product');
      this.productForm = this.section.querySelector('.js-product-form-main');
      this.optionSelectors = this.querySelectorAll('.option-selector');
      this.data = this.getProductData();

      // Get the variant from the URL
      const urlParams = new URLSearchParams(window.location.search);
      const variantId = urlParams.get('variant');

      const variants = this.data.product.variants;

      variants.forEach((variant, index) => {
        if (variant.id == variantId) {
          var variantstock = this.data.product.variants[index].available;

          if(variantstock){
            this.productForm.style.display = "block"
            var button = document.querySelector(".button--back-stock");
            if (button) {
              button.style.display = "none";
            }
          }else{
            if(this.productForm) {
              this.productForm.style.display = "none";
              var button = document.querySelector(".button--back-stock");
              if (button) {
                button.style.display = "block";
              }
            }
          }

        }
      });

      this.updateAvailability();
      this.addEventListener('change', this.handleVariantChange.bind(this));

      // Handle browser back/forward navigation (bfcache)
      window.addEventListener('pageshow', (event) => {
        if (event.persisted) {
          // Page was restored from bfcache, resync variant state
          const urlParams = new URLSearchParams(window.location.search);
          const variantId = urlParams.get('variant');
          
          if (variantId) {
            const variant = this.data.product.variants.find(v => v.id == variantId);
            
            if (variant) {
              // Resync the option selectors with the URL variant
              variant.options.forEach((optionValue, index) => {
                const selector = this.optionSelectors[index];
                
                if (selector.dataset.selectorType === 'dropdown') {
                  const customSelect = selector.querySelector('custom-select');
                  if (customSelect && customSelect.setValue) {
                    customSelect.setValue(optionValue);
                  }
                } else {
                  const input = selector.querySelector(`input[value="${optionValue}"]`);
                  if (input) {
                    input.checked = true;
                  }
                }
              });
              
              // Update the variant input in forms
              this.variant = variant;
              this.updateVariantInput();
              this.updateAddToCartButton();
              this.updateAvailability();
            }
          }
        }
      });
    }

    /**
     * Handles 'change' events on the variant picker element.
     * @param {object} evt - Event object.
     */
    handleVariantChange(evt) {
      const selectedOptions = this.getSelectedOptions();
      this.variant = null;

      // Get selected variant data (if variant exists).
      this.variant = this.data.product.variants.find((v) =>
        v.options.every((val, index) => val === selectedOptions[index])
      );

      if (this.variant) {
        this.updateMedia();
        this.updateUrl(evt);
        this.updateVariantInput();
      }

      this.updateAddToCartButton();
      this.updateAvailability();
      this.updatePrice();
      this.updateBackorderText();
      this.updatePickupAvailability();
      this.updateSku();
      VariantPicker.updateLabelText(evt);

      this.dispatchEvent(new CustomEvent('on:variant:change', {
        bubbles: true,
        detail: {
          form: this.productForm,
          variant: this.variant,
          product: this.data.product
        }
      }));
    }

    /**
     * Updates the "Add to Cart" button label and disabled state.
     */
    updateAddToCartButton() {
      this.productForm = this.section.querySelector('.js-product-form-main');
      if (!this.productForm) return;

      this.addBtn = this.addBtn || this.productForm.querySelector('[name="add"]');
      const variantAvailable = this.variant && this.variant.available;
      const unavailableStr = this.variant ? theme.strings.noStock : theme.strings.noVariant;

      this.addBtn.disabled = !variantAvailable;
      this.addBtn.textContent = variantAvailable
        ? this.addBtn.dataset.addToCartText
        : unavailableStr;

        if(variantAvailable){
          this.productForm.style.display = "block"
          var button = document.querySelector(".button--back-stock");
          if(button) {
            button.style.display = "none";
          }
      
        }else{
          this.productForm.style.display = "none";
          var button = document.querySelector(".button--back-stock");
          if(button) {
          button.style.display = "block";
          }
        }
    }

    /**
     * Updates the availability status in option selectors.
     */
    updateAvailability() {
      if (this.dataset.showAvailability === 'false') return;
      let currVariant = this.variant;

      if (!this.variant) {
        currVariant = { options: this.getSelectedOptions() };
      }

      const updateOptionAvailability = (optionEl, available, soldout) => {
        const el = optionEl;
        const text = soldout ? theme.strings.noStock : theme.strings.noVariant;
        el.classList.toggle('is-unavailable', !available);

        if (optionEl.classList.contains('custom-select__option')) {
          const em = el.querySelector('em');

          if (em) {
            em.hidden = available;
          }

          if (!available) {
            if (em) {
              em.textContent = text;
            } else {
              el.innerHTML = `${el.innerHTML} <em class="pointer-events-none">${text}</em>`;
            }
          }
        } else if (!available) {
          el.nextElementSibling.title = text;
        } else {
          el.nextElementSibling.removeAttribute('title');
        }
      };

      // Flag all options as unavailable
      this.querySelectorAll('.js-option').forEach((optionEl) => {
        updateOptionAvailability(optionEl, false, false);
      });

      // Flag selector options as available or sold out, depending on the variant availability
      this.optionSelectors.forEach((selector, selectorIndex) => {
        this.data.product.variants.forEach((variant) => {
          let matchCount = 0;

          variant.options.forEach((option, optionIndex) => {
            if (option === currVariant.options[optionIndex] && optionIndex !== selectorIndex) {
              matchCount += 1;
            }
          });

          if (matchCount === currVariant.options.length - 1) {
            const options = selector.querySelectorAll('.js-option');
            const optionEl = Array.from(options).find((opt) => {
              if (selector.dataset.selectorType === 'dropdown') {
                return opt.dataset.value === variant.options[selectorIndex];
              }
              return opt.value === variant.options[selectorIndex];
            });

            if (optionEl) {
              updateOptionAvailability(optionEl, variant.available, !variant.available);
            }
          }
        });
      });
    }

    /**
     * Updates the backorder text and visibility.
     */
    updateBackorderText() {
      this.backorder = this.backorder || this.section.querySelector('.backorder');
      if (!this.backorder) return;

      let hideBackorder = true;

      if (this.variant && this.variant.available) {
        const { inventory } = this.data.formatted[this.variant.id];

        if (this.variant.inventory_management && inventory === 'none') {
          const backorderProdEl = this.backorder.querySelector('.backorder__product');
          const prodTitleEl = this.section.querySelector('.product-title');
          const variantTitle = this.variant.title.includes('Default')
            ? ''
            : ` - ${this.variant.title}`;

          backorderProdEl.textContent = `${prodTitleEl.textContent}${variantTitle}`;
          hideBackorder = false;
        }
      }

      this.backorder.hidden = hideBackorder;
    }

    /**
     * Updates the color option label text.
     * @param {object} evt - Event object
     */
    static updateLabelText(evt) {
      const selector = evt.target.closest('.option-selector');
      if (selector.dataset.selectorType === 'dropdown') return;

      const colorText = selector.querySelector('.js-color-text');
      if (!colorText) return;

      colorText.textContent = evt.target.nextElementSibling.querySelector('.js-value').textContent;
    }

    /**
     * Updates the product media.
     */
    updateMedia() {
      if (!this.variant.featured_media) return;

      if (this.section.matches('quick-add-drawer')) {
        this.section.updateMedia(this.variant.featured_media.id);
      } else {
        this.mediaGallery = this.mediaGallery || this.section.querySelector('media-gallery');
        if (!this.mediaGallery) return;

        const variantMedia = this.mediaGallery.querySelector(
          `[data-media-id="${this.variant.featured_media.id}"]`
        );
        this.mediaGallery.setActiveMedia(variantMedia, true, true);
      }
    }

    /**
     * Updates the pick up availability.
     */
    updatePickupAvailability() {
      this.pickUpAvailability =
        this.pickUpAvailability || this.section.querySelector('pickup-availability');
      if (!this.pickUpAvailability) return;

      if (this.variant && this.variant.available) {
        this.pickUpAvailability.getAvailability(this.variant.id);
      } else {
        this.pickUpAvailability.removeAttribute('available');
        this.pickUpAvailability.innerHTML = '';
      }
    }

    /**
     * Updates the price.
     */
    updatePrice() {
      this.price = this.price || this.section.querySelector('.product-info__price > .price');
      if (!this.price) return;

      if (this.variant) {
        const priceCurrentEl = this.price.querySelector('.price__current');
        const priceWasEl = this.price.querySelector('.price__was');
        const unitPriceEl = this.price.querySelector('.unit-price');
        const priceLabelConseille = this.section.querySelector('.price-label-conseille');
        var promoPrice = this.data.formatted[this.variant.id].promo_price;
        // var calculFid = document.querySelector(".fid_points");
        var priceCurrentElText = priceCurrentEl.innerHTML;
        var tarif_revendeur = this.data.formatted[this.variant.id].tarifs_revendeurs;
        var type_revendeurs = this.data.formatted[this.variant.id].type_revendeurs
        
        // Update current price and original price if on sale.
        // var pointFid = parseFloat(document.querySelector('.fid_points_block').getAttribute("data-fid"));
        // var tvaFid = parseFloat(document.querySelector('.fid_points_block').getAttribute("data-tva"));

        function extraireNombre(texte) {
          var nombreExtrait = texte.replace(/[^\d,]/g, '');
          nombreExtrait = nombreExtrait.replace(',', '.');
          var nombre = parseFloat(nombreExtrait);
      
          return nombre;
        }

        if(priceCurrentElText.includes('HT')){
          if(type_revendeurs == "REV" || type_revendeurs == "REV2"){
            var pourcentage_final_price = extraireNombre(this.data.formatted[this.variant.id].price) * tarif_revendeur
            var pas_final_price = Math.floor((pourcentage_final_price / 100)* 100)/100
            var final_price = extraireNombre(this.data.formatted[this.variant.id].price) - pas_final_price
            
            var contenuTexte = priceCurrentEl.textContent;
            var montantEtUnite = contenuTexte.trim().split(' ');
            var uniteHT = montantEtUnite[1];
            
            priceCurrentEl.innerHTML = final_price.toFixed(2).toString().replace('.', ',') + " " + uniteHT + " HT";
          }else{
            if(promoPrice){
              // var myCalcPrice = ( parseInt(this.data.formatted[this.variant.id].promo_price) * tvaFid ) / 100 ;
              // var myNewPrice = parseInt(this.data.formatted[this.variant.id].promo_price) + myCalcPrice
              priceCurrentEl.innerHTML = this.data.formatted[this.variant.id].promo_price;
              // calculFid.innerHTML = Math.floor(myNewPrice) * pointFid
            }else{
              // var myPrice = extraireNombre(this.data.formatted[this.variant.id].price);
              // var myCalcPrice = ( Math.ceil(myPrice) * tvaFid ) / 100 ;
              // var myNewPrice = Math.ceil(myPrice) + myCalcPrice
              priceCurrentEl.innerHTML = this.data.formatted[this.variant.id].price;
              // calculFid.innerHTML = Math.floor(myNewPrice) * pointFid
            }
          }  
        }else if(priceCurrentElText.includes('TTC')){
            if(promoPrice){
              var myNewPrice = parseInt(this.data.formatted[this.variant.id].promo_price)
              priceCurrentEl.innerHTML = this.data.formatted[this.variant.id].promo_price;
              // calculFid.innerHTML = Math.floor(myNewPrice) * pointFid
            }else{
              var myNewPrice = parseInt(this.data.formatted[this.variant.id].price)
              priceCurrentEl.innerHTML = this.data.formatted[this.variant.id].price;
              // calculFid.innerHTML = Math.floor(myNewPrice) * pointFid
          }
        }

        var priceText = document.querySelector('.price__current').innerText;
        var match = priceText.match(/([\d,]+)/);
        var amountInCentimes = parseInt(match[1].replace(',', '') * 1);
        var myElement = document.querySelector('.qty-input__input').value
        
        var widgets = Alma.Widgets.initialize(
          '11u872H4kPi0Yt4Wwo6GSgFqTk6iVvCWAk', // ID marchand
          Alma.ApiMode.LIVE, // mode de l'API (LIVE ou TEST)
        )
      
        widgets.add(Alma.Widgets.PaymentPlans, {
          container: '#alma-widget',
          purchaseAmount: amountInCentimes * myElement,
          locale: 'fr',
          hideIfNotEligible: true,
          plans: [
            {
              installmentsCount: 2,
              minAmount: 5000,
              maxAmount: 100000,
            },
            {
              installmentsCount: 3,
              minAmount: 5000,
              maxAmount: 100000,
            },
            {
              installmentsCount: 4,
              minAmount: 5000,
              maxAmount: 100000,
            },
            {
              installmentsCount: 10,
              minAmount: 5000,
              maxAmount: 100000,
            },
          ],
        })

        // if(parseFloat(calculFid.innerHTML) == 0){
        //   document.querySelector(".block_fid").style.display = "none"
        // }else{
        //   document.querySelector(".block_fid").style.display = "block"
        // }

        if (priceWasEl) {
          // Gérer l'affichage du label et icône selon les règles
          var showIconConseille = false;
          var labelText = '';
          
          // Vérifier les prix dans l'ordre de priorité
          var prix_avant_reduction = this.data.formatted[this.variant.id].prix_avant_reduction;
          var prix_conseille = this.data.formatted[this.variant.id].prix_conseille;
          
          // PRIORITÉ 1: Prix avant réduction (label "Prix avant réduction", SANS icône)
          if (prix_avant_reduction && prix_avant_reduction > (this.variant.price / 100)) {
            // Diviser par 1.2 pour convertir TTC en HT
            var prix_avec_reduction = prix_avant_reduction / 1.2;
            var prix_formatted = parseFloat(prix_avec_reduction).toLocaleString('fr-FR', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            });
            
            var currentPriceFormat = this.data.formatted[this.variant.id].price;
            var hasSmallHT = currentPriceFormat.includes('<small>HT</small>');
            var hasSmallTTC = currentPriceFormat.includes('<small>TTC</small>');
            
            if (hasSmallHT) {
              priceWasEl.innerHTML = prix_formatted + ' € <small>HT</small>';
            } else if (hasSmallTTC) {
              priceWasEl.innerHTML = prix_formatted + ' € <small>TTC</small>';
            } else {
              priceWasEl.innerHTML = prix_formatted + ' €';
            }
            
            labelText = 'price_before_discount'; // Label "Prix avant réduction"
            showIconConseille = false; // PAS d'icône
          }
          // PRIORITÉ 2: Prix conseillé (label "Prix conseillé", AVEC icône)
          else if (prix_conseille && prix_conseille > (this.variant.price / 100)) {
            // Diviser par 1.2 pour convertir TTC en HT
            var prix_conseille_avec_reduction = prix_conseille / 1.2;
            var prix_conseille_formatted = parseFloat(prix_conseille_avec_reduction).toLocaleString('fr-FR', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            });
            
            var currentPriceFormat = this.data.formatted[this.variant.id].price;
            var hasSmallHT = currentPriceFormat.includes('<small>HT</small>');
            var hasSmallTTC = currentPriceFormat.includes('<small>TTC</small>');
            
            if (hasSmallHT) {
              priceWasEl.innerHTML = prix_conseille_formatted + ' € <small>HT</small>';
            } else if (hasSmallTTC) {
              priceWasEl.innerHTML = prix_conseille_formatted + ' € <small>TTC</small>';
            } else {
              priceWasEl.innerHTML = prix_conseille_formatted + ' €';
            }
            
            labelText = 'recommended_price'; // Label "Prix conseillé"
            showIconConseille = true; // AVEC icône
          }
          // PRIORITÉ 3: Compare at price (label "Prix avant réduction", SANS icône)
          else if(this.data.formatted[this.variant.id].compareAtPrice && !this.data.formatted[this.variant.id].promo_price == ""){
            priceWasEl.innerHTML = this.data.formatted[this.variant.id].compareAtPrice || '';
            if (this.data.formatted[this.variant.id].compareAtPrice) {
              labelText = 'price_before_discount';
              showIconConseille = false;
            } else {
              labelText = '';
              showIconConseille = false;
            }
          }else if(this.data.formatted[this.variant.id].price && !this.data.formatted[this.variant.id].promo_price && !this.data.formatted[this.variant.id].compareAtPrice && type_revendeurs?.includes('REV') && tarif_revendeur ){
            priceWasEl.innerHTML = this.data.formatted[this.variant.id].price || '';
            labelText = '';
            showIconConseille = false;
          }else if(this.data.formatted[this.variant.id].price && this.data.formatted[this.variant.id].promo_price && !this.data.formatted[this.variant.id].compareAtPrice ){
            priceWasEl.innerHTML = this.data.formatted[this.variant.id].price || '';
            labelText = '';
            showIconConseille = false;
          }else{
            priceWasEl.innerHTML = this.data.formatted[this.variant.id].compareAtPrice || '';
            if (this.data.formatted[this.variant.id].compareAtPrice) {
              labelText = 'price_before_discount';
              showIconConseille = false;
            } else {
              labelText = '';
              showIconConseille = false;
            }
          }
          
          // Mettre à jour le label
          if (priceLabelConseille) {
            if (labelText) {
              // Utiliser les traductions Shopify
              if (labelText === 'price_before_discount') {
                priceLabelConseille.textContent = window.theme?.strings?.price_before_discount || 'Prix avant réduction :';
              } else if (labelText === 'recommended_price') {
                priceLabelConseille.textContent = window.theme?.strings?.recommended_price || 'Prix conseillé :';
              }
              priceLabelConseille.style.display = '';
            } else {
              priceLabelConseille.style.display = 'none';
            }
          }
          
          // Mettre à jour l'icône (visible uniquement pour "Prix conseillé")
          const pictoItemConseille = this.section.querySelector('.picto-item-conseille');
          if (pictoItemConseille) {
            if (showIconConseille) {
              pictoItemConseille.style.visibility = 'visible';
              pictoItemConseille.style.display = '';
            } else if (labelText) {
              // Placeholder invisible pour maintenir l'alignement grid
              pictoItemConseille.style.visibility = 'hidden';
              pictoItemConseille.style.display = '';
            } else {
              pictoItemConseille.style.display = 'none';
            }
          }
        }

        // Update unit price, if specified.
        if (this.variant.unit_price_measurement) {
          const valueEl = this.price.querySelector('.unit-price__price');
          const unitEl = this.price.querySelector('.unit-price__unit');
          const value = this.variant.unit_price_measurement.reference_value;
          const unit = this.variant.unit_price_measurement.reference_unit;

          valueEl.innerHTML = this.data.formatted[this.variant.id].unitPrice;
          unitEl.textContent = value === 1 ? unit : `${value} ${unit}`;
        }

        unitPriceEl.hidden = !this.variant.unit_price_measurement;
        this.price.classList.toggle(
          'price--on-sale',
          this.variant.compare_at_price > this.variant.price
        );
        this.price.classList.toggle('price--sold-out', !this.variant.available);
      }

      this.price.querySelector('.price__default').hidden = !this.variant;
      this.price.querySelector('.price__no-variant').hidden = this.variant;
    }

    /**
     * Updates the SKU.
     */
    updateSku() {
      this.sku = this.sku || this.section.querySelector('.product-sku__value');
      if (!this.sku) return;

      const skuAvailable = this.variant && this.variant.sku;
      this.sku.textContent = skuAvailable ? this.variant.sku : '';
      this.sku.parentNode.hidden = !skuAvailable;
    }

    /**
     * Updates the url with the selected variant id.
     * @param {object} evt - Event object.
     */
    updateUrl(evt) {
      if (!evt || evt.type !== 'change' || this.dataset.updateUrl === 'false') return;
      window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.variant.id}`);
    }

    /**
     * Updates the value of the hidden [name="id"] form inputs.
     */
    updateVariantInput() {
      this.forms =
        this.forms || this.section.querySelectorAll('.js-product-form-main, .js-instalments-form');

      this.forms.forEach((form) => {
        const input = form.querySelector('input[name="id"]');
        input.value = this.variant.id;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

    /**
     * Gets the selected option element from each selector.
     * @returns {Array}
     */
    getSelectedOptions() {
      const selectedOptions = [];

      this.optionSelectors.forEach((selector) => {
        if (selector.dataset.selectorType === 'dropdown') {
          selectedOptions.push(selector.querySelector('.custom-select__btn').textContent.trim());
        } else {
          selectedOptions.push(selector.querySelector('input:checked').value);
        }
      });

      return selectedOptions;
    }

    /**
     * Gets the product data.
     * @returns {?object}
     */
    getProductData() {
      const dataEl = this.querySelector('[type="application/json"]');
      return JSON.parse(dataEl.textContent);
    }
  }

  customElements.define('variant-picker', VariantPicker);
}
